export default function Footer() {
    return (
        <footer className="footer w-full">
            <div className="w-full px-5">
                2022 © NEXAH.
            </div>
        </footer>
    )
}
